import { Home, Layers, MapPinned, Hammer, Trees, Waves } from "lucide-react";
import { Reveal, ChapterLabel } from "./Reveal";

const HIGHLIGHTS = [
  { icon: Trees, label: "Established residential community" },
  { icon: Layers, label: "Limited number of available homesites" },
  { icon: MapPinned, label: "Multiple lot sizes and locations" },
  { icon: Hammer, label: "Custom-home opportunity" },
  { icon: Home, label: "Cul-de-sac, corner and street-front options" },
  { icon: Waves, label: "Premier levee-side homesite available" },
];

export const About = () => (
  <section id="about" data-testid="about-section" className="bg-white py-24 lg:py-36 overflow-hidden">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid lg:grid-cols-12 gap-12 items-end mb-16">
        <div className="lg:col-span-6">
          <Reveal>
            <ChapterLabel number="03" title="About Woodlake Estates" />
            <h2 className="font-serif text-4xl sm:text-5xl text-forest leading-[1.05] tracking-tight">
              An Opportunity to Build in <span className="italic text-brass">Woodlake Estates</span>
            </h2>
          </Reveal>
        </div>
        <div className="lg:col-span-5 lg:col-start-8">
          <Reveal delay={0.1}>
            <div className="flex flex-col gap-5 font-sans text-base sm:text-lg leading-relaxed text-muted-foreground">
              <p>
                Woodlake Estates offers buyers the opportunity to design and build a custom home within an established
                residential community.
              </p>
              <p>
                The available homesites provide a variety of settings, including Platt Street frontage, Sequoia Street
                frontage, a corner property, a cul-de-sac location and a premier lot positioned along the Lake
                Pontchartrain levee.
              </p>
              <p>
                With only a limited number of properties available, buyers can select the homesite that best fits
                their vision, home design and lifestyle.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-border border border-border">
        {HIGHLIGHTS.map((h, i) => (
          <Reveal key={h.label} delay={0.08 * i} y={20}>
            <div data-testid={`about-highlight-${i}`} className="bg-white p-8 flex items-center gap-4 h-full">
              <h.icon size={20} className="text-brass shrink-0" />
              <span className="font-sans text-sm font-medium text-forest">{h.label}</span>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
